import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import ArchitectureIcon from '@mui/icons-material/Architecture';
import SettingsIcon from '@mui/icons-material/Settings';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import './Services.css'
// Simple SVGs for illustration. Replace or enhance icons as needed.
const icons = [
  (
    <ArchitectureIcon  sx={{ fontSize: 50, }}/>
  ),
  (
    <SettingsIcon sx={{ fontSize: 40, }}/>
  ),
  (
    <DocumentScannerIcon sx={{ fontSize: 40, }}/>
  ),
  (<ModelTrainingIcon sx={{ fontSize: 40,  }}/>
  )
];

const serviceData = [
  {
    title: "CAD Design & Detail Engineering",
    desc: "Providing high-quality CAD design and detailed engineering services for various industrial applications, ensuring precision and adherence to standards.",
    icon: icons[0],
  },
  {
    title: "CAD Customization & Automation",
    desc: "Tailoring CAD software to your specific needs and automating repetitive design tasks to significantly improve productivity and workflow efficiency.",
    icon: icons[1],
  },
  {
    title: "Digital Automation",
    desc: "Transforming your physical documents and legacy drawings into searchable, accessible digital formats, streamlining information management and access control.",
    icon: icons[2],
  },
  {
    title: "Custom AI Solutions",
    desc: "Developing bespoke AI-powered solutions to address unique business challenges, leveraging machine learning, data analytics, and intelligent automation.",
    icon: icons[3],
  },
];

const ServicesSection: React.FC = () => (
  <div className="services-bg">
    <Container>
      <div className="text-center mb-4">
        <h2 className="services-title">
          Our <span className="brand-gradient-text">Services</span>
        </h2>
        <div className="services-subtitle mx-auto">
          From foundational CAD expertise to cutting-edge AI, we offer a suite of services designed to elevate your engineering and business processes.
        </div>
      </div>
      <Row className="justify-content-center">
        {serviceData.map(({ title, desc, icon }, idx) => (
          <Col key={title} md="6" lg="3" className="mb-4 d-flex">
            <Card className="service-card flex-fill">
              <CardBody>
                <div className="icon-bg mb-3 justify-content-center">{icon}</div>
                <h5 className="mt-2 mb-2 fw-bold">{title}</h5>
                <p className="service-desc mb-0">{desc}</p>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </div>
);

export default ServicesSection;
